import api from "../apis/selectree_api";
import { getAuthHeader } from "../utilities/header";

export const getTreeDetail = tree_id => async dispatch => {
  try {
    if (tree_id) {
      const response = await api.get(
        `/tree/v2/detail/${tree_id}`,
        getAuthHeader()
      );
      return dispatch({ type: "GET_TREE_DETAIL", payload: response.data });
    } else {
      throw new Error("no id provided");
    }
  } catch (err) {
    console.log(`Error in client.actions.treeDetail: ${err}`);
    return dispatch({ type: "GET_TREE_DETAIL", payload: false });
  }
};

export const getTreeDetailV1 = treeName => async dispatch => {
  try {
    if (treeName) {
      const response = await api.get(
        `/tree/detail/${treeName}`,
        getAuthHeader()
      );
      return dispatch({ type: "GET_TREE_DETAIL", payload: response });
    } else {
      throw new Error("no id provided");
    }
  } catch (err) {
    console.log(`Error in client.actions.treeDetail: ${err}`);
    return dispatch({ type: "GET_TREE_DETAIL", payload: false });
  }
};

// Currently only used/implemented for family and genus
export async function getTreeOptions(field) {
  try {
    const response = await api.get(`/tree/${field}/options`);
    if (response && response.data) {
      return response.data;
    } else {
      return [];
    }
  } catch (err) {
    console.log(err);
    return [];
  }
}
